import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import MentorshipAPI from "~/services/MentorshipAPI";

interface MentorshipSession {
  id: number;
  mentor: {user: {first_name: string; last_name: string}};
  mentee: {first_name: string; last_name: string};
  topic: string;
  startTime: string; // ISO string
  endTime: string;   // ISO string
}

interface MentorshipSessionsListProps {
  username: string;
}

const MentorshipSessionsList: React.FC <MentorshipSessionsListProps> = ({username}) => {
  const [sessions, setSessions] = useState<MentorshipSession[]>([]);
  const [loading, setLoading] = useState(false);

  const columns: ColumnsType<MentorshipSession> = [
    {
      title: "Mentor",
      dataIndex: "mentor",
      key: "mentor",
      render: (user) => `${user.user.first_name} ${user.user.last_name}`
    },
    {
      title: "Mentee",
      dataIndex: "mentee",
      key: "mentee",
      render: (user) => `${user.first_name} ${user.last_name}`,
    },
    {
      title: "Title",
      dataIndex: "event_details",
      key: "title",
      render: (event_details) => event_details?.booking?.title || "N/A",
    },
    {
      title: "Date Created",
      dataIndex: "date_created",
      key: "date_created",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Start Time",
      dataIndex: "event_details",
      key: "event_details",
      render: (event_details) => {
        console.log({event_details});
        if (!event_details || !event_details.date) return "N/A";
        return new Date(event_details.date).toLocaleString();
      },
    },
  ];

  const mockSessions: MentorshipSession[] = [
  {
    id: 1,
    mentor: {user: {first_name: "Alice", last_name: "Johnson"}},
    mentee: {first_name: "Bob", last_name: "Smith"},
    topic: "React Fundamentals",
    startTime: "2025-08-14T10:00:00Z",
    endTime: "2025-08-14T11:00:00Z",
  },
  {
    id: 2,
    mentor: {user: {first_name: "Charlie", last_name: "Brown"}},
    mentee: {first_name: "Diana", last_name: "Prince"},
    topic: "AI No-Code Tools",
    startTime: "2025-08-15T14:00:00Z",
    endTime: "2025-08-15T15:30:00Z",
  },
];

  useEffect(() => {
    setSessions(mockSessions); // Using mock data for now
    
    setLoading(true);
    // MentorshipAPI.getBookings('Test123')
    MentorshipAPI.getBookings(username)
      .then((res) => {
        console.log({res});
        setSessions(res.data.sessions);
      })
      .catch(() => {
        message.error("Failed to load mentorship sessions");
      })
      .finally(() => {
        setLoading(false);
      });
      
  }, []);

  return (
    <Table<MentorshipSession>
      columns={columns}
      dataSource={sessions}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: 10 }}
    />
  );
};

export default MentorshipSessionsList;
